import { render, staticRenderFns } from "./Info_1.vue?vue&type=template&id=6457f111&scoped=true"
import script from "./Info_1.vue?vue&type=script&lang=js"
export * from "./Info_1.vue?vue&type=script&lang=js"
import style0 from "./Info_1.vue?vue&type=style&index=0&id=6457f111&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6457f111",
  null
  
)

export default component.exports